import iotDeviceConfig, {FEATURE_TYPES} from '../../../../services/iotDevice/iotDeviceConfig';
import iotDeviceFeatureConfigService from '../../../../services/iotDevice/iotDeviceFeatureConfigService';
import iotDeviceGlobalConfigService from '../../../../services/iotDevice/iotDeviceGlobalConfigService';
import iotDeviceSettingsService from '../../../../services/iotDevice/iotDeviceSettingsService';

const useAemFlexBatteryEnabled = (iotDevice) => {
    const isEnabledGlobally = iotDeviceGlobalConfigService.isGlobalAemFlexBattery(iotDevice);
    const isFeatureEnabled = iotDeviceFeatureConfigService.isAemFlexBatteryEnabled();
    const isFwuCanHelp = !iotDeviceConfig.isFeatureUpperBound(FEATURE_TYPES.AEM_FLEX_BATTERY);
    const isEnabled = iotDeviceSettingsService.isSettingAvailable(
        iotDevice,
        isEnabledGlobally,
        isFeatureEnabled,
        true,
        isFwuCanHelp
    );

    return isEnabled;
};

export default useAemFlexBatteryEnabled;
